import React from 'react'
import { Input, Select } from 'antd'
import { canViewStoreName } from '../../../../services/StorageServices'

const FilterBrandsRule = ({ handleChangeFieldSeach, hanldeChangeValueSearch, valueSearch, fieldSearch, placeholders }) => {
    const canViewStore = canViewStoreName()

    const _handleChangeSelect = (field) => {
        handleChangeFieldSeach(field)
    }

    const _handleChangeSearch = (e) => {
        hanldeChangeValueSearch(e.target.value)
    }

    return (
        <div className='FilterBrandsRule'>
            <Input.Group compact className='d-flex flex-nowrap'>
                <Select
                    value={fieldSearch}
                    style={{ minWidth: '30%' }}
                    onChange={_handleChangeSelect}
                >
                    {canViewStore && <Select.Option value="store">Store</Select.Option>}
                    <Select.Option value="brand_name">Brand name</Select.Option>
                    <Select.Option value="product_type">Product type</Select.Option>
                    <Select.Option value="tag">Order tag</Select.Option>
                </Select>
                <Input
                    style={{ width: '70%' }}
                    value={valueSearch}
                    placeholder={`Search ${placeholders[fieldSearch]}`}
                    onChange={_handleChangeSearch}
                />
            </Input.Group>
        </div>
    )
}

export default FilterBrandsRule